<div class="container">
  <div class="sidebar_container">
    <div class="sidebar_wrapper">
      <div class="options">
        <div class="card" *ngFor="let option of options" (click)="optionSelected(option.section)">
          <mat-icon> {{ option.icon }} </mat-icon>
          <h2> {{ option.displayName }} </h2>
        </div>
      </div>

      <div class="social-icons-container">
        <div style="display: block; margin: 0 6px;">
          <a class="social-icons"
            href="https://in.linkedin.com/in/huzaifa-anjum-90b117133?trk=public_profile_browsemap_mini-profile_title">
            <i class="fa fa-linkedin" style="color: #0e7687;"></i>
          </a>
        </div>

        <div style="display: block;">
          <a class="social-icons" href="https://www.facebook.com/huzaifa.rock.75">
            <i class="fa fa-facebook-f" style="color: #4267B2;" ></i>
          </a>
        </div>

        <div style="display: block;">
          <a class="social-icons" href="https://twitter.com/_huzaifaanjum_?s=03">
            <i class="fa fa-twitter" style="color: #1DA1F2;" ></i>
          </a>
        </div>

        <div style="display: block;">
          <a class="social-icons" href="https://www.instagram.com/_huzaifaanjum_">
            <i class="fa fa-instagram insta"></i>
          </a>
        </div>

        <div style="display: block;">
          <a class="social-icons" href="https://open.spotify.com/user/hfyhrwd4gyaut1lpozi6gwys4?si=AwsN2S3uTEeHWGsMDArZug">
            <i class="fa fa-spotify" style="color: #1DB954;"></i>
          </a>
        </div>

      </div>
    </div>
    <p style="margin-top: 20px; margin-bottom: 0;">	&copy; Huzaifa Anjum 2022. All rights reserved.</p>
  </div>

</div>
